import * as permissions from "@/app/Permissions";

export default function(perm, arg1, options) {
    options ??= arg1;
    if (permissions[perm](arg1)) return options.fn(this);
    return options.inverse(this);
}